/** @jsx jsx */
import { ReactNode } from 'react';

import { css, jsx } from '@emotion/react';

import Heading from '@atlaskit/heading';
import { token } from '@atlaskit/tokens';

import { displayFontStack } from '../shared';

const baseStyles = css({
  margin: token('space.0', '0px'), // @atlaskit/css-reset applies margin to headings
});

interface DisplayHeadingProps {
  testId?: string;
  headingTestId?: string;
  id?: string;
  level:
    | 'h900'
    | 'h800'
    | 'h700'
    | 'h600'
    | 'h500'
    | 'h400'
    | 'h300'
    | 'h200'
    | 'h100';
  as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'div' | 'span';
  color?: 'default' | 'inverse';
  style?: any;
  children: ReactNode;
}

/**
 * __Display heading__
 *
 * A display heading renders a heading using Charlie Display Font.
 */
const DisplayHeading = ({
  testId,
  headingTestId,
  id,
  level,
  as,
  color,
  style,
  children,
}: DisplayHeadingProps) => {
  const fontFamilyStyles = css({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage-spacing
    fontFamily: displayFontStack,
  });

  return (
    <div data-testid={testId} css={[baseStyles, fontFamilyStyles, style]}>
      <Heading
        id={id}
        level={level}
        as={as}
        testId={headingTestId}
        color={color}
      >
        {children}
      </Heading>
    </div>
  );
};

export default DisplayHeading;
